<template>
  <!-- Toast组件 - 类似微信toast样式 -->
  <transition name="toast-fade">
    <div v-if="visible" class="toast-container">
      <div class="toast-content">
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Toast组件
 * 类似微信的toast组件，支持自定义文案和时长
 * 多次显示时会显示最新的内容
 */
export default {
  name: 'Toast',
  data() {
    return {
      visible: false, // 控制toast显示状态
      message: '', // toast显示的文本内容
      timer: null, // 定时器引用
      duration: 2000 // 默认显示时长2秒
    }
  },
  methods: {
    /**
     * 显示toast
     * @param {string} text - 要显示的文本内容
     * @param {number} duration - 显示时长，默认2000ms
     */
    show(text, duration = 2000) {
      // 如果当前有toast正在显示，先清除定时器
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      
      // 设置新的内容和时长
      this.message = text
      this.duration = duration
      this.visible = true
      
      // 设置自动隐藏定时器
      this.timer = setTimeout(() => {
        this.hide()
      }, this.duration)
    },
    
    /**
     * 隐藏toast
     */
    hide() {
      this.visible = false
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  
  /**
   * 组件销毁前清理定时器
   */
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style scoped>
/* Toast容器样式 */
.toast-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  pointer-events: none; /* 不阻止用户操作 */
}

/* Toast内容样式 - 参考微信toast设计 */
.toast-content {
  background-color: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  max-width: 200px;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 淡入淡出动画效果 */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .toast-content {
    font-size: 13px;
    padding: 10px 14px;
    max-width: 180px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Toast.vue